import { usePromoCodeStore } from '@/stores/promoCode'
import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
  state: () => ({
    cartCount: 1,
    cartItems: [],
    apiUrl: useRuntimeConfig().public.apiUrl,
    productPackage: [],
    productPackageIds: [],
    totalPriceWithoutDiscount: 0,
    enableSecondItemDiscount: false,
    enableAdditionalDiscount: true,
    productIds: [],
  }),

  getters: {
    changeCartCount: (state) => state.cartCount + 11,

    totalPriceCart(state) {
      const promoCodeState = usePromoCodeStore(); // Pinia store для промокодов

      const total = (state.cartItems || []).reduce((total, item) => {
        const price = item.is_set === 1
          ? item.price
          : item.variant?.price ?? item.product.price;
        const itemTotal = price * item.quantity;
        const discount = item.discount_amount || 0;
        return total + itemTotal - discount;
      }, 0);

      let totalWithDiscount = total;

      if (promoCodeState.discountType && promoCodeState.discountData) {
        if (promoCodeState.discountType === 'PERCENT') {
          totalWithDiscount = total * (1 - promoCodeState.discountData / 100);
        } else if (promoCodeState.discountType === 'AMOUNT') {
          totalWithDiscount = total - promoCodeState.discountData;
        }
      }

      return Number(Math.max(0, totalWithDiscount).toFixed(2));
    },

    totalOldPriceCart(state) {
      return Number((state.cartItems || []).reduce((total, item) => {
        const oldPrice = item.variant?.old_price ?? item.product?.old_price ?? 0;
        return total + oldPrice * item.quantity;
      }, 0).toFixed(2));
    },

    totalDiscountAmount(state) {
      return Number((state.cartItems || []).reduce((total, item) => {
        const oldPrice = item.variant?.old_price ?? item.product?.old_price;
        const price = item.variant?.price ?? item.product.price;
        const defaultDiscount = oldPrice ? (oldPrice - price) * item.quantity : 0;
        const additionalDiscount = item.discount_amount || 0;
        return total + defaultDiscount + additionalDiscount;
      }, 0).toFixed(2));
    },

    getProductPackage: (state) => state.productPackage,
    getProductPackageIds: (state) => state.productPackageIds,
    getProductIds: (state) => state.productIds,
    totalPriceWithoutDiscount: (state) => state.totalPriceWithoutDiscount,

    cartItemCount(state) {
      return (state.cartItems || []).reduce((total, item) => total + item.quantity, 0);
    },
  },

  actions: {
    updateCartItems(newCartItems) {
      this.cartItems = newCartItems;
      localStorage.setItem('cart', JSON.stringify(newCartItems));
    },

    setProductPackage(productPackage) {
      this.productPackage = productPackage;
    },

    addProductPackageIds(productPackageIds) {
      this.productPackageIds = [...new Set([...this.productPackageIds, ...productPackageIds])];
    },

    // Изменено: добавлено логирование productIds и cartItems перед обновлением
    updateProductIds() {
      this.productIds = this.cartItems.map(item => item.product_id);
    },

    removeCartItem(itemId) {
      this.cartItems = this.cartItems.filter(item => item.id !== itemId);
      localStorage.setItem('cart', JSON.stringify(this.cartItems));
    },

    setDiscountFlags({ secondItem, additional }) {
      this.enableSecondItemDiscount = secondItem;
      this.enableAdditionalDiscount = additional;
    },

    applyDiscounts() {
      let cartItems = JSON.parse(JSON.stringify(this.cartItems)) || [];

      cartItems.forEach((item) => {
        item.discount_amount = 0;
      });


      const eligibleItems = cartItems.filter(item => !this.productPackageIds.includes(item.product.id));
      const totalQuantity = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);

      if (this.enableSecondItemDiscount) {
        const discountQuantity = Math.floor(totalQuantity / 2);

        if (discountQuantity > 0) {
          let sortedItems = eligibleItems.slice().sort((a, b) => {
            const priceA = a.variant?.price ?? a.product.price;
            const priceB = b.variant?.price ?? b.product.price;
            return priceA - priceB;
          });

          let remainingDiscountQuantity = discountQuantity;

          for (let item of sortedItems) {
            const unitPrice = item.variant?.price ?? item.product.price;
            const quantityToDiscount = Math.min(item.quantity, remainingDiscountQuantity);
            const discountPerUnit = unitPrice * 0.444444;
            item.discount_amount = discountPerUnit * quantityToDiscount;
            remainingDiscountQuantity -= quantityToDiscount;

            if (remainingDiscountQuantity <= 0) break;
          }
        }
      }

      if (this.enableAdditionalDiscount) {
        // price уже содержит скидку 10%, нужно довести итоговую скидку до 15%
        // т.е. нужно вычислить такую дополнительную скидку X, чтобы: (price - X) = originalPrice * 0.85
        // price = originalPrice * 0.9 => originalPrice = price / 0.9
        // (price - X) = (price / 0.9) * 0.85
        // X = price - (price / 0.9) * 0.85

        cartItems.forEach(item => {
          if (totalQuantity >= 2) {
            if (!this.productPackageIds.includes(item.product.id) && item.is_set !== 1) {
              const price = item.variant?.price ?? item.product.price;
              const additionalDiscountPerUnit = price - (price / 0.9) * 0.85;
              item.discount_amount += additionalDiscountPerUnit * item.quantity;
            }
          }
        });
      }

      this.updateCartItems(cartItems);
    },

    fetchCartFromLocalStorage() {
      const cart = localStorage.getItem("cart");
      console.log("Получен cart из localStorage:", cart);
      if (cart) {
        this.updateCartItems(JSON.parse(cart));
        this.updateProductIds();
        this.applyDiscounts();
      }
    },

    updateCart(newCartItems) {
      this.updateCartItems(newCartItems);
      this.updateProductIds();
      this.applyDiscounts();
    }
  }
});